import {
  AdvancedCareProviderFilterMenuConfig,
  AdvancedCareProviderFilterType,
} from "@/modules/care-provider/advanced-search/types/AdvancedCareProviderFilter"

export const ADVANCED_CARE_PROVIDER_FILTER_MENU = new Map<
  AdvancedCareProviderFilterType,
  AdvancedCareProviderFilterMenuConfig
>([
  [
    "careProviderGroups",
    { label: "admin.careProviders.advancedSearch.filter.group", type: "singleSelect", analyticsSuffixKey: "group" },
  ],
  [
    "specialties",
    {
      label: "admin.careProviders.advancedSearch.filter.specialty",
      type: "singleSelect",
      isSearchable: true,
      analyticsSuffixKey: "specialty",
    },
  ],
  ["foci", { label: "admin.careProviders.advancedSearch.filter.focus", type: "singleSelect", isSearchable: true }],
  [
    "specializations",
    {
      label: "admin.careProviders.advancedSearch.filter.specialization",
      type: "singleSelect",
      isSearchable: true,
    },
  ],
  ["subjectAreas", { label: "admin.careProviders.advancedSearch.filter.subjectArea", type: "singleSelect" }],
  ["services", { label: "admin.careProviders.advancedSearch.filter.service", type: "singleSelect" }],
  [
    "cantons",
    { label: "admin.careProviders.advancedSearch.filter.canton", type: "singleSelect", analyticsSuffixKey: "canton" },
  ],
  [
    "officialLanguages",
    {
      label: "common.languages",
      type: "multipleSelect",
      isSearchable: true,
      analyticsSuffixKey: "language",
    },
  ],
  [
    "diagnosticFacilities",
    {
      label: "admin.careProviders.advancedSearch.filter.diagnosticFacilities",
      type: "multipleSelect",
      isSearchable: true,
      analyticsSuffixKey: "facilities",
    },
  ],
  [
    "certificates",
    {
      label: "admin.careProviders.advancedSearch.filter.certificates",
      type: "multipleSelect",
      isSearchable: true,
      analyticsSuffixKey: "certification",
    },
  ],
  ["features", { label: "admin.careProviders.advancedSearch.filter.features.title", type: "multipleSelect" }],
  [
    "isWalkIn",
    {
      label: "admin.careProviders.advancedSearch.filter.isWalkIn",
      type: "booleanSelect",
      analyticsSuffixKey: "takes_WalkIn",
    },
  ],
  [
    "isTakesNewPatients",
    {
      label: "admin.careProviders.advancedSearch.filter.takesNewPatients",
      type: "booleanSelect",
      analyticsSuffixKey: "newPatient",
    },
  ],
  [
    "isMedgatePartnerNetworkMember",
    { label: "admin.careProviders.advancedSearch.filter.isMPN", type: "booleanSelect", analyticsSuffixKey: "mpn" },
  ],
  [
    "isInsurerNetworkMember",
    {
      label: "admin.careProviders.advancedSearch.filter.isInsurerNetwork",
      type: "booleanSelect",
      analyticsSuffixKey: "insurerNetwork",
    },
  ],
])
